import { get, patch, post } from '../../utils/http';

export const fetchEmployeeContracts = ({ accountId, employeeId }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/contracts`);

export const assignContractToEmployee = ({ accountId, employeeId, contractId, startDate }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/contracts`, { contractId, startDate });

export const adjustEmployeeContract = ({ accountId, employeeId, employeeContractId, values }) =>
  patch(`/accounts/${accountId}/employees/${employeeId}/contracts/${employeeContractId}`, values);

export const addPtoDays = ({ accountId, employeeId, employeeContractId, startDate, endDate, type, branchId }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/contracts/${employeeContractId}/pto`, {
    branchId,
    type,
    startDate,
    endDate
  });

export const addEmployeePtoBalanceAdjustment = ({ accountId, employeeId, employeeContractId, amount, reason, type }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/contracts/${employeeContractId}/pto-balance-adjustment`, {
    amount,
    reason,
    type
  });

export const fetchEmployeeContractPtoInfo = ({ accountId, employeeId, employeeContractId }) =>
  get(`/accounts/${accountId}/employees/${employeeId}/contracts/${employeeContractId}/pto-info`);

export const terminateEmployeeContract = ({ accountId, employeeId, employeeContractId, endDate }) =>
  patch(`/accounts/${accountId}/employees/${employeeId}/contracts/${employeeContractId}/terminate`, { endDate });

// Deleting a PTO lives on the payroll router now — see removePtoForPayrollQuery in accounts-payroll.

export const useAllPtoBalance = ({ accountId, employeeId, employeeContractId, branchId, date }) =>
  post(`/accounts/${accountId}/employees/${employeeId}/contracts/${employeeContractId}/use-all-pto`, {
    branchId,
    date
  });
